import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="defer-paint w-full bg-paper py-12 sm:py-14" aria-labelledby="faq-heading" data-id="element-78" data-mp="1bl23p9e8x8f0">
      <div className="mx-auto max-w-3xl px-6" data-id="element-79" data-mp="1gj3llqzxr1ow">
        <div className="text-center" data-id="element-80" data-mp="1gjvkbaotxfje">
          <p className="eyebrow text-green-deep" data-id="element-81" data-mp="249g4fwwpyiu9">Antes de decidir</p>
          <h2 id="faq-heading" className="mt-4 font-display text-[1.9rem] font-bold leading-[1.12] text-ink sm:text-[2.3rem]" data-id="element-82" data-mp="24bapdb7zqayc">
            Preguntas frecuentes
          </h2>
        </div>

        <ul className="mt-10 space-y-2.5" data-id="element-83" data-mp="1uj4o1avumh6h">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`rounded-3xl border bg-shell transition-colors duration-150 ease-out ${isOpen ? 'border-green/50' : 'border-line'}`} data-id="element-84" data-mp="2n822f2wxvtty" data-mpi={index}>
                <h3 data-id="element-85" data-mp="2s03eanq73ijg">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 rounded-3xl px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green" data-id="element-86" data-mp="2s0lfzzvmmoyr">
                    <span className="font-display text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-87" data-mp="19tc1j1kkrumt">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-green bg-green text-shell' : 'border-green/25 bg-green-soft text-green-deep'}`} aria-hidden="true" data-id="element-88" data-mp="1jkgg406c9dh4">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-89" data-mp="1sis3ltbwrv5c" />
                    </span>
                  </button>
                </h3>

                <div id={`faq-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-90" data-mp="3uec7vzvp5nds">
                  <div className="overflow-hidden" data-id="element-91" data-mp="23a106uegvucd">
                    <p className="px-6 pb-6 font-sans text-[0.92rem] leading-relaxed text-muted" data-id="element-92" data-mp="2867ufpxi3heh">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}